import { useState } from 'react';
import filesStyles from '~/styles/myEnvironment/files.module.css';
import formatDate from '~/helpers/formatDate';
import useTranslation from '~/hooks/useTranslation';
import Button from '../General/Button';
import IconDownload from '~icons/tabler/download';

type File = {
  id: number;
  name: string;
  url: string;
  type: string;
  size: number;
  created_at: string;
  updated_at: string;
};

type Props = {
  className?: string;
  files: File[];
};

export default function Files({
  className,
  files,
}: Props) {
  const translate = useTranslation();
  const [startedDownloading, setStartedDownloading] = useState<string[]>([]);

  return (
    <div className={className}>
      <ul className={filesStyles.files}>
        {files.map((file) => (
          <li key={file.id} className={filesStyles.file}>
            <div>
              <strong className={filesStyles.fileName}>
                {file.name}
              </strong>

              <div className={filesStyles.fileMeta}>
                {`${translate('myEnvironment.reservation.file_uploaded_at')}: ${formatDate(file.created_at)}`}
              </div>
            </div>

            <div>
              <Button
                type="link"
                href={file.url}
                onClick={() => setStartedDownloading([...startedDownloading, file.url])}
                disabled={startedDownloading.includes(file.url)}
              >
                <IconDownload />
                <span>
                  {translate('myEnvironment.reservation.file_download')}
                </span>
              </Button>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
